import { SurveyTemplate, SurveyTemplateQuery } from '@dreryk/egabinet-survey-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

const PREINTERVIEW_TEMPLATE_CODE = 'PREINTERVIEW';

type SurveyPreInterviewTemplateFormLoaderRenderProps = {
   surveyTemplate: SurveyTemplate;
   refetchSurveyTemplate: VoidFunction;
};

type SurveyPreInterviewTemplateFormLoaderProps = {
   readonly children: (renderProps: SurveyPreInterviewTemplateFormLoaderRenderProps) => JSX.Element;
};

export const SurveyPreInterviewTemplateFormLoader = (props: SurveyPreInterviewTemplateFormLoaderProps): JSX.Element => {
   const {
      data: surveyTemplate,
      error: surveyTemplateError,
      refetch: refetchSurveyTemplate,
      fetching: fetchingSurveyTemplate,
   } = useCqrsGet<SurveyTemplate>(() => {
      const query = new SurveyTemplateQuery();
      query.templateCode = Slot.emptyIfNull(PREINTERVIEW_TEMPLATE_CODE);
      return query;
   });

   if (fetchingSurveyTemplate) {
      return <LoaderSpinner />;
   }

   if (surveyTemplateError) {
      return (
         <Message
            testId={'surveyTemplateFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      surveyTemplate: surveyTemplate,
      refetchSurveyTemplate: refetchSurveyTemplate,
   });
};
